import { getCoreRowModel } from "@tanstack/react-table"
import type { FC } from "react"

import type { DestinationOverride } from "../GoodsReceiptPalletsTable"

import { useGoodsReceiptPalletsEditableColumns } from "./hooks/useGoodsReceiptPalletsEditableColumns"

import { AerosBaseTable } from "@/components/Tables/Aeros/components/AerosBaseTable"
import type { GoodsReceiptPallet, WarehouseArea } from "@/graphql/codegen/graphql"

interface GoodsReceiptPalletsEditableTableProps {
  pallets: GoodsReceiptPallet[]
  warehouse?: WarehouseArea | null
  destinationOverrides?: Map<string, DestinationOverride>
  isSyncing?: boolean
  isLoading?: boolean
  canMaintain: boolean
  openActionsMenuId: string | null
  onActionsMenuOpen: (palletId: string) => void
  onActionsMenuClose: () => void
  onDestinationOverride?: (pallet: GoodsReceiptPallet) => void
  onLpnEdit?: (pallet: GoodsReceiptPallet) => void
  onQrPrint?: (pallet: GoodsReceiptPallet) => void
  onDelete?: (pallet: GoodsReceiptPallet) => void
}

export const GoodsReceiptPalletsEditableTable: FC<GoodsReceiptPalletsEditableTableProps> = ({
  pallets,
  warehouse,
  destinationOverrides,
  isSyncing = false,
  isLoading = false,
  canMaintain,
  openActionsMenuId,
  onActionsMenuOpen,
  onActionsMenuClose,
  onDestinationOverride,
  onLpnEdit,
  onQrPrint,
  onDelete,
}) => {
  const columns = useGoodsReceiptPalletsEditableColumns({
    destinationOverrides,
    warehouse,
    isSyncing,
    canMaintain,
    openActionsMenuId,
    onActionsMenuOpen,
    onActionsMenuClose,
    onDestinationOverride,
    onLpnEdit,
    onQrPrint,
    onDelete,
  })

  return (
    <AerosBaseTable<GoodsReceiptPallet>
      features={{
        table: {
          stickyHeader: true,
        },
        tanstackOptions: {
          data: pallets,
          columns,
          enableSorting: false,
          getCoreRowModel: getCoreRowModel(),
          getRowId: (row) => row.goodsReceiptPalletId,
          state: { isLoading },
        },
      }}
      noDataMessage='No pallets found'
    />
  )
}
